













import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "content-header-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderControl.vue")
  }
})
export default class ContentHeaderUpgradeControl extends Vue {}
